import { render } from "./SearchQueryAnalyticsList.vue?vue&type=template&id=3bf72dce&scoped=true"
import script from "./SearchQueryAnalyticsList.vue?vue&type=script&lang=js"
export * from "./SearchQueryAnalyticsList.vue?vue&type=script&lang=js"

import "./SearchQueryAnalyticsList.vue?vue&type=style&index=0&id=3bf72dce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf72dce"]])

export default __exports__